/**
 * Why the v2 board's activity affordances are disabled — ONE string, shared by the page's control bar
 * and the table's column caption, because a reader comparing the two must not be given two different
 * explanations of the same empty column.
 *
 * **One cause again, as of 2026-08-13.** The copy used to name two without distinguishing them,
 * because the payload could not: the counts arrived `null` both when the backend read flag was off and
 * when the viewer was not an admin. The admin-only carve-out is retired (DASH-2a spec §5 item 4 —
 * activity now reaches every viewer of the board), so the only remaining cause is the read flag, and
 * saying "limited to a smaller group" would now be the untrue half.
 *
 * Note this string is about the numbers being ABSENT, not about them being empty. A viewer who sees
 * live controls and flat sparklines is looking at real, sparse data — most deals genuinely have no
 * attributed activity yet — which is a different message and deliberately not this one.
 */
export const ACTIVITY_UNAVAILABLE_REASON =
  'Activity numbers are not switched on for this board yet. Disabled rather than hidden so a control ' +
  'that exists is never mistaken for a feature that does not.';
